/* RESPONSIBLE TEAM: team-actions */
export const TRIGGER_PREDICATE_PREFIX = 'operator_workflow_trigger';
